import { useCallback, useEffect, useState } from 'react';
import { LiveTranscriptionMessage } from '@zoom/videosdk';

import { useZoomCall } from 'hooks';

const Captions = () => {
  const { isEnableCaptions, room } = useZoomCall();
  const [message, setMessage] = useState('');

  const handleCaptionMessage = useCallback(
    (payload: LiveTranscriptionMessage) => {
      if (!room || payload.userId === room.getCurrentUserInfo()?.userId) return;
      setMessage(payload.text);
    },
    [room]
  );

  useEffect(() => {
    room?.on('caption-message', handleCaptionMessage);
    return () => {
      room?.off('caption-message', handleCaptionMessage);
    };
  }, [room, handleCaptionMessage]);

  if (!message || !isEnableCaptions) return null;

  return (
    <div className="absolute inset-x-0 bottom-[220px] mx-auto w-fit max-w-[90%] rounded-lg bg-black/90 p-2 text-white md:bottom-[120px]">
      {message}
    </div>
  );
};

export default Captions;
